import { createStorageDriver, memoryStorage } from "@exonn/storage";

export const memoryStorageDriver = createStorageDriver(memoryStorage);
